import { useCallback } from 'react'

import type { WebSocketMessage } from '@features/websocket/core/types'
import {
  TransactionEvent,
  normalizeTransactionWebSocketEvent,
} from '@features/websocket/transactions/transactionEvent'
import { useTransactionWebSocketMessage } from '@features/websocket/transactions/useTransactionWebSocketMessage'

const DECLINED_EVENTS: TransactionEvent[] = [
  TransactionEvent.Declined,
  TransactionEvent.Failed,
  TransactionEvent.Cancelled,
]

interface UseQrDepositStatusListenerParams {
  transactionId?: string
  enabled: boolean
  onSuccess(): void
  onDeclined(): void
}

export const useQrDepositStatusListener = ({
  transactionId,
  enabled,
  onSuccess,
  onDeclined,
}: UseQrDepositStatusListenerParams): void => {
  const handleMessage = useCallback(
    (message: WebSocketMessage) => {
      if (!enabled || !transactionId) return

      const event = normalizeTransactionWebSocketEvent(message)
      if (!event || event.transactionId !== transactionId) return

      if (event.type === TransactionEvent.Completed) {
        onSuccess()
        return
      }

      if (DECLINED_EVENTS.includes(event.type)) {
        onDeclined()
      }
    },
    [enabled, transactionId, onSuccess, onDeclined]
  )

  useTransactionWebSocketMessage(handleMessage, enabled && Boolean(transactionId))
}
